export const FETCH_UNPAID_TICKETS = 'tickets/FETCH_UNPAID_TICKETS';
export const FETCH_UNPAID_TICKETS_SUCCESS =
  'tickets/FETCH_UNPAID_TICKETS_SUCCESS';
export const FETCH_UNPAID_TICKETS_FAILURE =
  'tickets/FETCH_UNPAID_TICKETS_FAILURE';

export const COMPLETE_TICKET = 'tickets/COMPLETE_TICKET';
export const COMPLETE_TICKET_SUCCESS = 'tickets/COMPLETE_TICKET_SUCCESS';
export const COMPLETE_TICKET_FAILURE = 'tickets/COMPLETE_TICKET_FAILURE';

export const SAVE_TICKET = 'tickets/SAVE_TICKET';
export const SAVE_TICKET_SUCCESS = 'tickets/SAVE_TICKET_SUCCESS';
export const SAVE_TICKET_FAILURE = 'tickets/SAVE_TICKET_FAILURE';

export const fetchUnpaidTickets = (): IAction => ({
  type: FETCH_UNPAID_TICKETS,
});

export const fetchUnpaidTicketsSuccess = <T>(payload: T): IAction => ({
  type: FETCH_UNPAID_TICKETS_SUCCESS,
  payload,
});

export const fetchUnpaidTicketsFailure = <T>(payload: T): IAction => ({
  type: FETCH_UNPAID_TICKETS_FAILURE,
  payload,
});

export const completeTicket = (): IAction => ({
  type: COMPLETE_TICKET,
});

export const completeTicketSuccess = <T>(payload: T): IAction => ({
  type: COMPLETE_TICKET_SUCCESS,
  payload,
});

export const completeTicketFailure = <T>(payload: T): IAction => ({
  type: COMPLETE_TICKET_FAILURE,
  payload,
});

export const saveTicket = (): IAction => ({
  type: SAVE_TICKET,
});

export const saveTicketSuccess = <T>(payload: T): IAction => ({
  type: SAVE_TICKET_SUCCESS,
  payload,
});

export const saveTicketFailure = <T>(payload: T): IAction => ({
  type: SAVE_TICKET_FAILURE,
  payload,
});
